// LIBRARIES
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  MARGIN,
  SIZE,
} from "constants/variables";
import styled from "styled-components";

// Define the styled components
export const ParentContainer = styled.div`
  margin-top: 120px;
  width: 100%;
  height: 963px;
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.Crimson};
  display: flex;
  flex-direction: column;
  padding: 80px 0px;
  position: relative;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    height: auto;
  }
`;

export const Title = styled.div`
  width: 369px;
  margin-bottom: 24px;
  margin-left: ${SIZE.max84};
`;

export const Section = styled.div`
  display: flex;
  flex-direction: row;
  gap: 80px;
  width: 100%;
  height: 100%;
  margin-left: 80px;
  margin-right: 80px;
  position: relative;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    flex-direction: column;
    gap: 40px;
    margin-left: 24px;
    margin-right: 24px;
    padding-right: 24px;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    width: auto;
    padding-right: 0px;
  }
`;

export const CardContainer = styled.div<{
  colSpan: number;
  rowSpan: number;
  isImage?: boolean;
}>`
  grid-column: span ${({ colSpan }) => colSpan};
  grid-row: span ${({ rowSpan }) => rowSpan};
  border-radius: ${BORDER_RADIUS.radius21};
  overflow: hidden;
  background-color: ${COLORS.FaluRed};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  position: relative;
`;

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: ${COLORS.Background};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CardTitle = styled.h2`
  margin: 0;
  text-align: center;
  max-width: 346px;
`;

export const CardContent = styled.div`
  /* text-align: center; */
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

export const CardIllustration = styled.img`
  position: absolute;
  top: -107px;
  right: -107px;
  width: 255px;
  height: 255px;
`;

export const SectionIllustration = styled.img`
  position: absolute;
  bottom: -168px;
  right: -168px;
  width: 400px;
  height: 400px;
  rotate: calc(90deg);
`;

export const SectionSecondIllustration = styled.img`
  position: absolute;
  left: -173px;
  top: 330px;
  width: 398.75px;
  height: 398.75px;
`;

export const TabsWrapper = styled.div`
  margin-bottom: 48px;
  width: 100%;
  height: 80px;
`;

export const LeftSideWrapper = styled.div`
  transition: 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  width: 55%;
  height: 100%;
  gap: 24px;
  /* background-color: blue; */
  max-width: 624px;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 100%;
    gap: 16px;
    padding-right: 24px;
    max-width: 100%;
  }
`;

export const ImageCard = styled.img`
  width: 100%;
  height: 264px;
  border-radius: ${BORDER_RADIUS.radius24};
  object-fit: cover;
  background-position: center;
  background-color: ${COLORS.Background};
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    width: 100%;
    height: 224px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Line = styled.div`
  display: flex;
  height: auto;
  width: 2px;
  background-color: ${COLORS.MetalicSilver};
  opacity: 0.4;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    margin-right: 24px;
    height: 2px;
    width: auto;
  }
`;

export const RightSideWrapper = styled.div`
  transition: 0.3s ease-in-out;
  height: 650px;
  width: auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
  margin-right: 150px;
  gap: 32px;
  /* Track */
  ::-webkit-scrollbar-track {
    background: ${COLORS.Background};
    border-radius: ${BORDER_RADIUS.radius8};
    border-radius: ${BORDER_RADIUS.radius8};
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.Yellow};
    border-radius: ${BORDER_RADIUS.radius8};
  }
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    margin-right: 24px;
    max-height: 350px;
    overflow-y: scroll;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    gap: 24px;
    margin-right: 0px;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: -8px;
`;

export const ButtonContainer = styled.div`
  width: 129px;
  height: 42px;
  border-radius: ${BORDER_RADIUS.radius21};
`;

export const SmallImageCard = styled.img`

  background-position: center;
  background-color: ${COLORS.Background};
  width: 200px;
  height: 175px;
  border-radius: ${BORDER_RADIUS.radius24};
  object-fit: cover;
  display:block;
  flex-shrink: 0;
`;

export const ArticleRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: center;
  justify-content: center;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const ArticleContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const ArticleTitleWrapper = styled.div`
  margin-bottom: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-direction: row;
  width: 90%;
  padding-right: 80px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    margin-bottom: 8px;
    gap: 12px;
    width: 100%;
  }
`;
export const NoDataTitleWrapper = styled.div`
  text-align: center;
`;

export const ArticleBodyWrapper = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 80%;
  margin-bottom: 24px;
`;

export const SkeletonWrapperHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${MARGIN.fix16};
  margin-top: ${MARGIN.max10};
`;

export const NoDataContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: ${SIZE.max32};
`;

export const SvgContainer = styled.div`
  height: auto;
  width: auto;
  margin-bottom: ${MARGIN.max32};
  opacity: 0.4;
  > svg {
    height: ${SIZE.max360};
    width: ${SIZE.max360};
  }
`;
